export const i18nCasePage = {
  analytics: {
    cases: 'Casos',
    cases_by_stage: 'Casos por etapa',
    actions: 'Acciones',
    pieChartSelect: {
      actions: {
        type_case_action: 'Acciones por tipo',
        status: 'Estado de acción',
      },
      cases: {
        dimension: 'Dimensión',
        discipline: 'Disciplina',
        detectionMethod: 'Método de detección',
      },
    },
  },
  goToStageBanner: {
    message: '¿Quieres cambiar la etapa a {{stage}}?',
    not_permitted: 'Para cambiar a la etapa {{stage}}, todas las acciones deben ejecutarse.',
  },
  goToStage: {
    title: '¿Quieres cambiar la etapa a {{stage}}?',
    message:
      'Para crear una nueva acción, debe dejar el escenario {{currentStage}} y ir a {{stage}}.',
    no: 'No, quédate en {{currentStage}}',
    yes: 'Sí, vaya a {{stage}}',
  },
  ableToOperate: {
    tag: {
      active: 'Capaz de operar',
      inactive: 'Incapaz de operar',
    },
    modal: {
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      label: '¿El activo puede operar?',
      description:
        'Si el activo se establece como "No puede operar", se activará una alarma cuando se encienda. También puede cambiar el estado operativo en la página del activo.',
      title: 'Estado operativo del activo',
    },
    options: {
      yes: 'Capaz de operar',
      no: 'Incapaz de operar',
    },
  },
  externalReference: {
    title: 'Referencias externas',
    tooltip: {
      plural: '{{value}} acciones',
      singular: '{{value}} acción',
    },
    not_found: 'No encontrado',
    'open-critical': 'Aberto crítico',
    'open-non-critical': 'Aberto no crítico',
    closed: 'Cerrado',
  },
  related: {
    table: {
      title: 'Añadir alarma vinculada al equipo',
    },
    addEdit: 'Añadir/Editar',
  },
  table: {
    agreg: '#',
    alarm_datetime_start: 'Inicio',
    asset: 'Equipo',
    is_assigned_to_case: '',
    classification: 'Clasificación',
    delete: '',
    description: 'Nombre',
    id: 'ID',
    link: '',
    name: 'Título',
    notif: '',
    records: 'Registros',
    severity: 'Severidad',
    status: 'Etapa',
    is_automatic: 'Auto',
    is_automatic_blocked_tooltip:
      'No se puede cambiar el estado automático de alarmas vinculadas a un caso existente.',
    new_alarms: 'nuevo',
  },
  buttons: {
    edit: 'Editar / Abrir completo',
    evidences: 'Evidencias ({{quantity}})',
    records: 'Registros ({{quantity}})',
    relatedEvents: 'Eventos relacionados ({{quantity}})',
    newAction: 'Nueva acción',
    newCase: 'Nuevo caso',
    casesPage: 'Pág. de casos',
    expandCase: 'Expandir caso',
  },
  filters: {
    allCategories: 'Todas categ. de activos',
    allOwners: 'Todos los propietarios',
    search: 'Buscar',
  },
  title: {
    cases: 'Cases',
    diagnosis: 'Diagnóstico',
    actions: 'Acciones ({{quantity}})',
    diagnosisValidation: 'Validación de diagnóstico',
    feedback: 'Feedback',
    externalReference: 'Referencia externa',
  },
  status: {
    diagnosis: 'Diagnóstico',
    actions: 'Acciones',
    execution: 'Ejecución',
    on_hold: 'En espera',
    feedback: 'Feedback',
    canceled: 'Cancelado',
    closed: 'Cerrado',
  },
  inputs: {
    dimension: 'Dimensión',
    discipline: 'Disciplina',
    severity: 'Severidad',
    anomaly_start: 'Inicio de la anomalía',
    anomaly_end: 'Fin de la anomalía',
    diagnosis: 'Diagnóstico',
    team_a_review: 'Revisión del equipo A',
    team_b_review: 'Revisión del equipo B',
    asset: 'Equipo',
    detection_method: 'Método de detección',
    // Action
    type: 'Tipo',
    maintenanceNotification: 'Notificación de mantenimiento',
    status: 'Estado',
    dueDate: 'Fecha de vencimiento',
    creationDate: 'Fecha de creación',
    executionDate: 'Fecha de ejecución',
    executionFeedback: 'Feedback de ejecución',
    details: 'Detalles',
    is_able_to_operate: 'Capaz de operar',
    equipment_class: 'Clase de equipo',
    subunit: 'Subunidad',
    failure_mode: 'Modo de fallo',
    failure_mechanism: 'Mecanismo de fallo',
    total_estimated_cost: 'Total estimado (USD)',
    maintainable_item: 'Elemento mantenible',
    maintenance_scope: 'Alcance del mantenimiento',
  },
  placeholders: {
    caseTitle: 'Ingrese el título del caso aquí',
    actionTitle: 'Ingrese título',
    awaitingDiagnoseClosure: 'Esperando el cierre del diagnóstico',
    diagnosis: 'Ingrese los detalles del diagnóstico',
    selectAnOption: 'Seleccione una opción',
    selectUser: 'Seleccione usuario',
    selectAsset: 'Seleccione el activo',
    comments: 'Comentarios',
    owner: 'Propietario: Usted',
    availableWithStatus: 'Disponible al ingresar la fecha de ejecución.',
    enterCode: 'Introducir código',
    enterDetails: 'Introducir detalles',
    enterNotificationNumber: 'Introduzca el número de notificación',
    pickDate: 'Seleccionar fecha',
    select: 'Seleccionar',
    typeText: 'Ingrese cualquier comentario sobre la ejecución de la acción.',
  },
  tooltips: {
    newActionNotAllowed: "Las nuevas acciones sólo se pueden agregar en el estado 'Acciones'.",
    enterDetails: 'Introducir detalles',
    enterNotificationNumber: 'Introduzca el número de notificación',
    select: 'Seleccionar',
    typeText: 'Insira el texto',
    no_changes: 'No hay cambios para guardar por ahora',
  },
  severity: {
    very_high: 'Muy alta',
    high: 'Alta',
    medium: 'Media',
    low: 'Baja',
    minor: 'Menor',
  },
  dimension: {
    dynamic_condition: 'Condición dinámica',
    auxiliary_system: 'Sistema auxiliar',
    process_condition: 'Condición del proceso',
    oil_analysis: 'Análisis de petróleo',
  },
  discipline: {
    rotative: 'Rotativo',
    electrical: 'Eléctrico',
    instrumentation: 'Instrumentación',
    process: 'Proceso',
    automation: 'Automatización',
    others: 'Otros',
    EMPTY: 'Ninguno',
  },
  conclusion: {
    label: 'Conclusión sobre la anomalía',
    no_issue_found: 'No se encontró problema',
    solved_completely: 'Resuelto completamente',
    solved_partially: 'Resuelto parcialmente',
    not_solved: 'No resuelto',
  },
  team_review: {
    rejected: 'Rechazado',
    accepted: 'Aceptado',
  },
  actions: {
    status: {
      on_track: 'En camino',
      delayed: 'Demorado',
      executed: 'Ejecutado',
      none: 'Ninguno',
    },
    type_case_action: {
      maintenance: 'Mantenimiento',
      operations: 'Operaciones',
    },
  },
  created: 'Creado',
  last_edition_by: 'Última edición: {{updatedAt}} | @{{username}}',
  mandatory_fields: '* Campos obligatorios para la siguiente etapa',
  main_tabs: {
    OPEN: 'Abierto',
    CLOSED: 'Cerrado',
    ALL: 'Todos',
  },
  table_tabs: {
    cases: 'Casos',
    actions: 'Acciones',
  },
  tabs: {
    evidences: 'Evidencias y Docs ({{quantity}})',
    relatedAlarms: 'Alarmas vinculadas ({{quantity}})',
    relatedCases: 'Casos vinculados ({{quantity}})',
  },
  status_count_panel: {
    empty_data: 'No hay datos disponibles para filtrar',
    severity: {
      title: 'Severidad',
      4: 'Muy Alta',
      3: 'Alta',
      2: 'Media',
      1: 'Baja',
    },
    status: {
      action_status: {
        title: 'Estado de la acción',
        on_track: 'En camino',
        delayed: 'Retrasado',
        all_executed: 'Todos Ejecutados',
        executed: 'Ejecutado',
        none: 'Ninguno',
      },
      total: { title: 'Total', total: 'Casos' },
      status: {
        title: 'Estado',
        OPEN: 'Abierto',
        CLOSED: 'Cerrado',
      },
    },
    stage: {
      title: 'Estado',
      actions: 'Acciones',
      canceled: 'Cancelado',
      closed: 'Cerrado',
      diagnosis: 'Diagnóstico',
      feedback: 'Respuesta',
      on_hold: 'En espera',
      none: 'Ninguno',
    },
  },
  common: {
    actions: 'Acciones',
    action_status: 'Estado de la acción',
    anomaly_start: 'Inicio de la anomalía',
    anomaly_end: 'Fin de la anomalía',
    asset: 'Equipo',
    cancel: 'Cancelar',
    category: 'Categoría',
    created: 'Creado',
    description: 'Descripción',
    diagnosis: 'Diagnóstico',
    dimension: 'Dimensión',
    discipline: 'Disciplina',
    event_code: 'ID',
    external_reference: 'Referencia externa',
    external_reference_code: 'Código',
    external_reference_summary: 'Ref. ext.',
    name: 'Título',
    none: 'Ninguno',
    owner_mail: 'Propietario',
    save: 'Guardar',
    severity: 'Severidad',
    start_date: 'Creado',
    status: 'Etapa',
    updated_at: 'Última edición',
    alarms_30_days: 'Alarmas 30d',
    closed_date: 'Cerrada',
    preview: 'Vista previa',
  },
  no_data: {
    list: 'No hay casos disponibles para los ajustes filtrados.',
    related_alarms: 'No se agregó ninguna alarma relacionada',
    related_alarms_modal: 'Este equipo no tiene alarmas en el período seleccionado',
    empty_actions: 'No se han creado acciones hasta el momento.',
  },
  new: 'Nuevo',
  new_case: 'Nuevo Caso',
  new_action: 'Nuevo Acción',
  expand: 'Expandir lista',
  show_analytics: 'Mostrar Analytics',
  expand_tutorial_title: 'Presentando Insights Visuales',
  expand_tutorial_description:
    'Tu lista de casos ahora incluye gráficos para obtener insights rápidos. Usa "Expandir Lista" para volver a la vista completa de la lista.',
  expand_tutorial_button: 'Entendido',
  delete: 'Eliminar',
  cancel: 'Cancelar',
  confirm_delete: 'Si, eliminar',
  continue_anyway: 'Continuar de todo modo',
  messages: {
    create: {
      title: '¡Éxito!',
      message: 'Nuevo caso creado con éxito',
    },
    edit: {
      title: '¡Éxito!',
      message: 'Cambios aplicados con éxito',
    },
    delete: {
      title: '¿Eliminar acción y perder todos sus datos?',
      message:
        'Esta acción contiene información que se perderá. ¿Está seguro de que desea continuar?',
    },
    delete_asset: {
      title: 'Las alarmas relacionadas se eliminarán si cambia el activo.',
      message: '¿Está seguro de que desea continuar?',
    },
    attach_exit_without_saving: {
      title: 'Dejar de asociar alarmas con un caso existente?',
      button: {
        primary: 'Si, salir',
        secondary: 'No, volver',
      },
    },
    cancel: {
      title: 'Por que desea cancelar el caso?',
      placeholder: 'Por favor, explique el motivo de la cancelación',
      button: {
        primary: 'Cancelar caso',
        secondary: 'Volver',
      },
    },
    diagnosis_not_filled: {
      title: 'Por favor, complete todos los campos obligatorios',
      message:
        'Antes de pasar a la etapa de Acciones, es necesario completar los campos Título, Activo y Diagnóstico.',
      button: {
        ok: 'OK',
      },
    },
    diagnosis_to_actions: {
      title: '¿Terminar Diagnóstico y ir a Acciones?',
      message:
        'El diagnóstico se guardará y el estado cambiará a Acciones, para poder crear acciones.',
      button: {
        go_to_actions: 'Sí, ir a Acciones',
        cancel: 'Cancelar',
      },
    },
  },
  records: {
    creation_date: 'Fecha de creación',
    name: 'Nombre de la acción',
    case_name: 'Nombre del caso',
    type_case_action: 'Tipo',
    details: 'Detalles',
    external_reference: 'Tipo de Referencia externa',
    code: 'Código de Referencia externa',
    owner_mail: 'Propietario',
    status: 'Estado',
    due_date: 'Fecha de vencimiento',
    end_date: 'Fecha de ejecución',
    dimension: 'Dimensión',
    severity: 'Severidad',
    low: 'Baja',
    medium: 'Media',
    high: 'Alta',
    very_high: 'Muy alta',
    anomaly_start: 'Inicio de la anomalía',
    anomaly_end: 'Fin de la anomalía',
    detection_method: 'Método de detección',
    diagnosis: 'Diagnóstico',
    discipline: 'Disciplina',
    conclusion: 'Conclusión',
    feedback: 'Feedback',
    actions: 'Acciónes',
    feedback_comments: 'Comentarios de feedback',
    feedback_conclusion: 'Conclusión de feedback',
    title: 'Registros',
    add_a_comment: 'Agregar un comentario',
    view_records: 'Ver registros',
    event_records: 'Registros de eventos',
    attachments: 'Adjuntos',
    comments: 'Comentarios',
    summary: {
      attachments: 'Adjuntos',
      comments: 'Comentarios',
      last_update: 'Última actualización: ',
    },
    category: {
      alarm_created: 'Alarma creada',
      alarm_visualized: 'Alarma visualizada',
      alarm_closed: 'Alarma cerrada',
      attached_file: 'Archivo adjunto',
      detached_file: 'Archivo desadjuntado',
      comment: 'Comentario',
    },
  },
  evidences: {
    title: 'Evidencias y Documentos ({{quantity}})',
    new: 'Nuevo',
    attach: 'Adjuntar',
    attached: 'Adjunto',
    no_data: 'No hay evidencias disponibles',
    undo: 'Deshacer',
    drag_file_here: 'Arrastra y suelta aquí',
    drop_file_here: 'Suelta el archivo aquí',
    search_in_device: 'Buscar en mi dispositivo',
    upload_not_available: 'Upload no disponible en este contexto',
    upload_files_to_continue: 'Sube archivos para continuar',
    save_attched_files: 'Guardar archivos adjuntos',
    messages: {
      exit: {
        title: '¡Atención!',
        message: 'Si sale sin guardar, estos cambios se perderán.',
      },
      repetead: {
        title: 'Lo siento, hay archivos adjuntos con el mismo nombre',
        message: 'Por favor, renombre el archivo antes de seleccionarlo.',
      },
      mandatory: {
        title: 'Lo sentimos, no se pudo guardar el estado.',
        message:
          'Por favor, rellene todos los campos obligatorios (con *) antes de cambiar de estado.',
      },
      tooltip:
        'Formatos de archivo permitidos: XLS, TXT, PDF, DOC, JPG y PNG con tamaño hasta 10 Mb',
      tooltipRevert: 'Deshacer eliminación',
      upload_success: 'Archivos subidos con éxito',
      upload_failed: 'Error al subir archivos, por favor intente de nuevo.',
      delete_success: 'Archivo eliminado con éxito',
      delete_error: 'Error al eliminar el archivo, por favor intente de nuevo.',
      some_uploads_failed: 'No se pudieron subir {{count}} archivos',
    },
    buttons: {
      exit: 'Salir de todos modos',
      back: 'Regresar',
      ok: 'Ok',
    },
  },
  savings: {
    title: 'Savings',
    has_savings: {
      no: 'No',
      yes: 'Sí',
    },
  },
  tooltip: {
    asset_title_mandatory: 'Debe ingresar el título del caso y el equipo para continuar.',
  },
  Cases: {
    openAsset: 'abrir activo',
    newCd: 'Nuevo DC',
    openNewCD: 'Crear nueva Desviación de Condición',
    editCD: 'Editar Desviación de Condición',
    asset: 'Activo',
    asset_id: 'ID de lo Activo',
    dimension: 'Dimensión',
    category: 'Categoría',
    category_id: 'Id de la categoría',
    detection_method: 'Método de detección',
    deviation_start: 'Inicio de desviación',
    deviation_end: 'Fin de desviación',
    duration: 'Duración',
    diagnosis: 'Diagnóstico',
    detailing: 'Detalle',
    recommended_action: 'Acciones recomendadas',
    actionStatus: 'Estado de la acción',
    sap_note: 'Nota',
    sapNoteTooltip: 'El campo de nota es obligatorio con el estado de acción "Acción emitida"',
    assetConditionEvaluation: 'Evaluación de condición',
    condition_evaluation: 'Evaluación de condición',
    assetStatus: 'Estado del activo',
    savings: 'Ahorros',
    savings_required: 'Ahorros',
    savingsNoteTooltip: 'Ahorros es un campo opcional y se puede completar en cualquier momento',
    description: 'Descripción',
    equipment_class: 'Clase de activo',
    subunit: 'Subunidad',
    maintainable_item: 'Elemento mantenible',
    failureMode: 'Modo de fallo',
    failure_mechanism: 'Mecanismo de fallo',
    maintenance_scope: 'Alcance del mantenimiento',
    noFillesAttached: 'No hay archivos adjuntos',
    attachFile: 'Adjuntar archivo',
    alarmsLinked: '{{alarmsCount}} Alarmas vinculadas',
    toThisCD: 'a esta Desviación de Condición',
    addViewAlarms: 'Añadir/ver asset Alarmas de activos',
    caseOwner: 'Proprietária:',
    is_out_of_service: '¿El equipo puede operar?',
    outOfServiceOptions: {
      yes: 'Capaz de operar',
      no: 'Incapaz de operar',
    },
    options: {
      tooltip: {
        actions:
          'Por favor, complete todos los campos obligatorios en Diagnóstico antes de cambiar el estado.',
        feedback:
          'Las acciones deben tener estado “Ejecutado” o “Cancelado” (guardado) para ir a Feedback.',
        closed:
          'Por favor, complete todos los campos obligatorios en Feedback antes de cambiar a Cerrado.',
      },
      action_status: {
        INVESTIGATING: 'Investigando',
        ACTION_ISSUED: 'Acción emitida',
        CANCELED: 'Cancelado',
        UNDER_EVALUATION: 'En evaluación',
        COMPLETED: 'Completado',
      },
      condition_evaluation: {
        NORMAL_CONDITION: 'Normal',
        ALARM_CONDITION: 'Medio',
        CRITICAL_CONDITION: 'Alto',
        POTENTIAL_PROBLEM: 'Muy Alto',
        NOT_MONITORED: 'No Monitoreado',
        NOT_OPERATED: 'No Operado',
        modec: {
          NORMAL_CONDITION: 'Condição Normal',
          ALARM_CONDITION: 'Condição de Alarme',
          CRITICAL_CONDITION: 'Condição Crítica',
          POTENTIAL_PROBLEM: 'Problema Potencial',
          NOT_MONITORED: 'No Monitoreado',
          NOT_OPERATED: 'No Operado',
        },
      },
      dimensions: {
        AUXILIARY_SYSTEM: 'Sistema auxiliar',
        PROCESS_CONDITION: 'Condición de proceso',
        DYNAMIC_CONDITION: 'Condición dinámica',
        OIL_ANALYSIS: 'Análisis de petróleo',
      },
    },
    confirmChangeAsset:
      'Si cambia el Activo, las alarmas vinculadas se borrarán. ¿Continuar de todos modos?',
    yesContinue: 'Sí, continuar',
    save: 'Guardar',
    placeholders: {
      assetName: 'Seleccionar activo',
      dimension: 'Seleccionar dimensión',
      selectAnOption: 'Seleccionar una opción',
      select: 'Seleccionar',
      dayHour: 'Elegir día y hora',
      diagnosis: 'Introducir diagnóstico de desviación',
      detailing: 'Introducir detalles',
      recommendedActions: 'Introducir recomendaciones',
      sapCode: 'Introducir Nota',
      description: 'Un breve resumen sobre el evento de ahorro',
    },
    messages: {
      duplicate_attribute_name: 'Nombre de atributo duplicado',
      only_numbers: 'Sólo números',
      toBeRequired: 'Este campo es obligatorio',
      confirmTurnOffCannotOperate:
        '¿Está seguro de que desea APAGAR el estado NO PUEDE FUNCIONAR para este equipo?',
      confirmTurnOnCannotOperate:
        '¿Está seguro de que desea ACTIVAR el estado NO PUEDE FUNCIONAR para este equipo?',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    modalTitles: {
      new: 'Crear nueva Desviación de Condición',
      edit: 'Desviación de Condición',
    },
    conditionEvaluation: {
      POTENTIAL_PROBLEM: 'Alto',
      CRITICAL_CONDITION: 'Muy Alto',
      ALARM_CONDITION: 'Medio',
      NORMAL_CONDITION: 'Bajo',
    },
  },
  tableColumns: {
    severity: 'Severidad',
    start_date: 'Inicio',
    name: 'Nombre',
    dimension: 'Dimensión',
    discipline: 'Disciplina',
    status: 'Estado',
    action_status: 'Estado de la acción',
    externalReference: 'Ref. ext.',
    updated_at: 'Última actualización',
  },
  components: {
    casesByAssetTable: {
      name: 'Activo',
      bar: 'Casos',
      count: '#',
    },
    casesByOwnerTable: {
      owner_mail: 'Propietario',
      cases: 'Casos',
      number: '#',
      no_data: 'No hay datos disponibles',
    },
  },

  actions_table: {
    creation_date: 'creación',
    name: 'Nombre',
    case_name: 'Nombre del caso',
    type_case_action: 'Tipo',
    details: 'Detalles',
    external_reference_type: 'Ref. externa',
    external_reference: 'Código',
    owner_mail: 'Propietario',
    status: 'Estado',
    due_date: 'vencimiento',
  },
  error: {
    noOpenCases: 'No hay casos abiertos en el período seleccionado.',
    noClosedCases: 'No hay casos cerrados en el período seleccionado.',
    noCases: 'No hay casos en el período seleccionado y los filtros seleccionados.',
  },
  assetCases: 'Casos de activos',
};
